<template>
    <div class='login-container mobile'>
      <div class='contract-content-gratitude' style='padding: 0; display: none'>
        <div
            style='padding: 0'
            v-for="(item, index) in contractList"
            :key="index"
        >
          <div class='contract-content-info-gratitude' style='padding: 0 20px 20px 20px;'>
            <div class='contract-title-input' style='margin-bottom: 20px; margin-top: 20px; background-color: white'
                 :style='`font-size: ${18}px`'>
              감사 추적 인증서
            </div>

            <div class='contract-title-input' style='margin-bottom: 1px; margin-top: 1px; background-color: #CCCCCC; height: 1px; padding-bottom: 0; padding-top: 0'/>

            <div class='contract-info-title' style='margin-top: 10px'
                 :style='`font-size: ${16}px`'>문서 정보</div>
            <div style='display: flex'>
              <div class='contract-info-sub-title mobile-title'
                   :style='`font-size: 14px`'>문서 이름</div>
              <div class='contract-info-sub-title' v-show='templateSendId > 0'
                   :style='`font-size: 14px`'>{{item.e_contract_title}}</div>
            </div>
            <div style='display: flex'>
              <div class='contract-info-sub-title mobile-title'
                   :style='`font-size: 14px`'>문서 ID</div>
              <div class='contract-info-sub-title' v-show='templateSendId > 0'
                   :style='`font-size: 14px`'>{{item.e_id}}</div>
            </div>
            <div style='display: flex'>
              <div class='contract-info-sub-title mobile-title'
                   :style='`font-size: 14px`'>상태</div>
              <div class='contract-info-sub-title' v-show='templateSendId > 0'
                   :style='`font-size: 14px`'>{{item.templateSendStatus | getContractStatus}}</div>
            </div>
            <div style='display: flex'>
              <div class='contract-info-sub-title mobile-title'
                   :style='`font-size: 14px`'>기준 시간</div>
              <div class='contract-info-sub-title' v-show='templateSendId > 0'
                   :style='`font-size: 14px`'>(UTC+09:00) 한국 표준시</div>
            </div>
            <div style='display: flex'>
              <div class='contract-info-sub-title mobile-title'
                   :style='`font-size: 14px`'>페이지수</div>
              <div class='contract-info-sub-title' v-show='templateSendId > 0'
                   :style='`font-size: 14px`'>1P</div>
            </div>


            <div class='contract-title-input' style='margin-bottom: 1px; margin-top: 15px; background-color: #CCCCCC; height: 1px; padding-bottom: 0; padding-top: 0'/>
            <div class='contract-info-title' style='margin-top: 10px'
                 :style='`font-size: ${16}px`'>서명 요청자</div>
            <div style='display: flex'>
              <div class='contract-info-sub-title mobile-title'
                   :style='`font-size: 14px`'>이름</div>
              <div class='contract-info-sub-title' v-show='templateSendId > 0'
                   :style='`font-size: 14px`'>{{item.centerName}}</div>
            </div>

            <div class='contract-title-input' style='margin-bottom: 1px; margin-top: 15px; background-color: #CCCCCC; height: 1px; padding-bottom: 0; padding-top: 0'/>
            <div style='display:flex'>
              <div style='width:50%'>
                <div class='contract-info-title' style='margin-top: 10px;'
                     :style='`font-size: 16px`'>서명 참여자</div>
                <div style='display: flex'>
                  <div class='contract-info-sub-title mobile-title' style='width: 100px'
                       :style='`font-size: 14px`'>이름</div>
                  <div class='contract-info-sub-title' v-show='templateSendId > 0'
                       :style='`font-size: 14px`'>{{item.recipientName}}</div>
                </div>
                <div style='display: flex'>
                  <div class='contract-info-sub-title mobile-title' style='width: 100px'
                       :style='`font-size: 14px`'>연락처</div>
                  <div class='contract-info-sub-title' v-show='templateSendId > 0'
                       :style='`font-size: 14px`'>{{item.recipientPhone | phoneNumberFilter}}</div>
                </div>
                <div style='display: flex'>
                  <div class='contract-info-sub-title mobile-title'  style='width: 100px'
                       :style='`font-size: 14px`'>상태</div>
                  <div class='contract-info-sub-title' v-show='templateSendId > 0'
                       :style='`font-size: 14px`'>{{item.templateSendStatus | getContractStatus}}</div>
                </div>
              </div>
              <div style='width:50%'>
                <div class='contract-info-title'  style='margin-top: 10px;'
                     :style='`font-size: 16px`'>서명</div>
                <div style='display: flex; align-items: center; margin-top: 8px'>
                  <img class='contract-info-signature mobile-sign' v-show='recipientSignImageRawData != ""' :class='recipientSignImageRawData == "" ? "no-image" : ""' :src='`${recipientSignImageRawData}`' />
                </div>
              </div>
            </div>

            <div class='contract-title-input' style='margin-bottom: 1px; margin-top: 15px; background-color: #CCCCCC; height: 1px; padding-bottom: 0; padding-top: 0'/>
            <div class='contract-info-title' style='margin-top: 10px'
                 :style='`font-size: 16px`'>진행 이력</div>
            <div
                style='padding: 0'
                v-for="(log, idx) in item.templateLog"
                :key="idx"
            >
              <div style='display: flex'>
                <div class='contract-info-sub-title mobile-title' style='width: 30%'
                     :style='`font-size: 14px`'>{{log.createdAt | timestampFilter2}}</div>
                <div class='contract-info-sub-title' v-show='templateSendId > 0' style='width: 30%'
                     :style='`font-size: 14px`'>{{log.regName}}</div>
                <div class='contract-info-sub-title' v-show='templateSendId > 0' style='color: blue; width: 40%'
                     :style='`font-size: 14px`'>{{log.status | getContractStatus}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class='contract-content' style='padding: 0; '>
        <div
            style='padding: 0'
            v-for="(item, index) in contractList"
            :key="index"
        >
          <div class='contract-content-info' style='padding: 0 20px 20px 20px;'>
            <div class='contract-title-input' style='margin-bottom: 20px; margin-top: 20px; background-color: white'
                 :style='`font-size: 16px`'>
              {{item.e_contract_title}}
            </div>
            <div class='contract-info-title'
                 :style='`font-size: 16px`'>서명정보</div>
            <div style='display: flex'>
              <div class='contract-info-sub-title mobile-title'
                   :style='`font-size: 14px`'>이름</div>
              <div class='contract-info-sub-title' v-show='templateSendId > 0'
                   :style='`font-size: 14px`'>{{item.recipientName}}</div>
            </div>
            <div style='display: flex'>
              <div class='contract-info-sub-title mobile-title'
                   :style='`font-size: 14px`'>연락처</div>
              <div class='contract-info-sub-title' v-show='templateSendId > 0'
                   :style='`font-size: 14px`'>{{item.recipientPhone | phoneNumberFilter}}</div>
            </div>
            <div v-show='item.ticketInfo !== undefined'>
              <div class='contract-info-title' v-show='item.e_contract_member_type === "M"'
                   :style='`font-size: 14px`'>이용권 정보</div>
              <div v-show='templateSendId > 0 && item.e_contract_member_type === "M"'>
                <div v-for='(ticketInfo, index) in JSON.parse(item.ticketInfo)' :key='index' class='ticket-container'>
                  <div class='ticket-box' :style='`font-size: 14px`'>
                    <div class='ticket-box-title'>{{ticketInfo.title}}</div>
                    <div class='ticket-box-info'>
                      <div style='flex: 1'>
                        {{ticketInfo.period}}
                      </div>
                      <div>
                        {{ticketInfo.price}}원
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class='contract-info-title'
                 :style='`font-size: 16px`'>약관</div>
            <div style='padding: 10px 10px 0 10px' v-for='(it, i) in item.templateInfo'>
              <div v-if='it.type == 1'>
                <div class='contract-info-sub-title' style='display: flex'>
                  <div style='flex: 1; word-break: break-all'
                       :style='`font-size: 14px`'>{{it.title}}</div>
                </div>
                <textarea class='contract-info-sub-title area' style='resize: none; background-color: transparent; color: #333333; opacity: 1' disabled
                          :style='`font-size: 14px`'>{{it.content}}</textarea>
              </div>
              <div v-else style='display: flex'>
                <div style='flex: 1;'>
                  <div class='contract-info-sub-title' style='display: flex'>
                    <div style='flex: 1;'
                         :style='`font-size: 14px`'>{{it.title}}</div>
                  </div>
                  <textarea class='contract-info-sub-title area' style='resize: none; background-color: transparent; color: #333333; opacity: 1' disabled
                            :style='`font-size: 14px`'>{{it.content}}</textarea>
                  <div v-for='(jt, j) in it.options' style='display: flex; align-items: center; margin-top: 10px'>
                    <div class='com-check'>
                      <input
                          :id='`agree-check-${index}-${i}-${j}`'
                          v-model='jt.checked'
                          name='check-c1'
                          type='checkbox'
                          @change='onCheckOption'
                          :disabled='item.templateSendStatus != "S"'
                      />
                      <label :for='`agree-check-${index}-${i}-${j}`' class='agree-option border-red'><div v-show='it.requiredFlag' class='check-required'>*</div></label>
                    </div>
                    <div class='agree-option-input'
                         :style='`font-size: 14px`'>{{jt.title}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class='contract-info-title' style='flex: 1;' v-show='templateSendId > 0'
                 :style='`font-size: 16px`'>{{item.sendTime | dateFormatFilter2}}</div>
            <div style='display: flex' v-show='templateSendId > 0'>
              <div class='' style='flex: 1;'
                   :style='`font-size: 16px`'></div>
              <div style='width: 260px; margin-top: 10px'>
                <div style='display: flex; align-items: center'>
                  <div class='contract-info-person'
                       :style='`font-size: 14px`'>수신인 {{item.recipientName ? (": " + item.recipientName) : ""}}</div>
                  <div class='contract-info-signature no-image' v-show='recipientSignImageRawData == ""' :style='`font-size: 14px; width: 80px; height:56px !important; line-height:56px !important`'>(서명)</div>
                  <img class='contract-info-signature mobile-sign' v-show='recipientSignImageRawData != ""' :class='recipientSignImageRawData == "" ? "no-image" : ""' :src='`${recipientSignImageRawData}`' />
                </div>
                <div style='display: flex; align-items: center; margin-top: 10px;'>
                  <div class='contract-info-person'
                       :style='`font-size: 14px`'>발신인 {{item.centerName ? (": " + item.centerName) : ""}}</div>
                  <div class='contract-info-signature no-image' v-show='senderSignImageRawData == ""' :style='`font-size: 14px; width: 80px; height:56px !important; line-height:56px !important`'>(서명)</div>
                  <img class='contract-info-signature mobile-sign' v-show='senderSignImageRawData != ""' :class='senderSignImageRawData == "" ? "no-image" : ""' :src='`${senderSignImageRawData}`' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class='contract-content-result'>
        <div class='login-wrap'>
            <div class='input-area'>
                <div style='width: 100%; text-align: center'>
                    <img class='login-image' src='/img/icons/ic_login_logo.png' />
                </div>
                <div class='login-contractor'>{{item && item.templateSendStatus | getContractResultTitleStatusStr}}</div>
                <div class='login-contractor-desc'>카카오톡 알림톡에서 {{item && item.templateSendStatus | getContractResultContentStatusStr}}를 <br>확인하실 수 있습니다.</div>
            </div>
        </div>
        <div class='btn-result-area'>
            <button class='com-btn btn-mobile-login' v-show='item && item.templateSendStatus === "R"' @click='send_email'>이메일 전송하기</button>
            <button class='com-btn btn-mobile-confirm' @click='contract_confirm'>계약서 확인하기</button>
        </div>
      </div>
      <div v-show="sendEmailPop" class="layer-pop square">
        <div class="view-content" style='width: 370px; padding: 0 !important;'>
          <div class="com-scroll-y confirm-dlg-box" style='padding-bottom: 10px !important;'>
            <div style='margin-bottom: 5px;'>
              <div style='flex: 1; font-size: 18px; color: #00a4e8; font-weight: bold'>이메일을 입력해 주세요.</div>
              <div style='flex: 1; font-size: 18px; color: #333333; margin-top: 5px; margin-bottom: 5px'>계약 완료한 문서를 전송할<br />이메일을 입력해 주세요.</div>
            </div>
            <input v-model.trim='sendEmail'
                   autofocus
                   placeholder='이메일을 입력해 주세요.'
                   type='email'
                   style='margin-top: 10px; margin-bottom: 15px; font-size: 18px; padding: 5px; position: relative; z-index: 100'
            />
          </div>
          <div style='display: flex'>
            <button class="mobile-dlg-btn" @click="handleCancelSendEmail">취소</button>
            <button class="mobile-dlg-btn active" @click="handleConfirmSendEmail">확인</button>
          </div>
        </div>
      </div>
      <loading-spinner v-if="isLoading" style='z-index: 5000; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5)'></loading-spinner>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import {convertImgToDataURLviaCanvas} from '@/assets/js/common';
import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default {
    name: 'ContractResult',
  components: {LoadingSpinner},
    props: {},
    computed: {
    },
    data() {
        return {
            templateSendId: this.$route.params.id,
            contractList: [],
            item: null,

            recipientSignImageRawData: "",
            senderSignImageRawData: "",

            pdfFiles:[],
            pdfFile1 : null,
            pdfFile2 : null,
            uploadEmailFiles:[],
            sendEmailPop: false,
            sendEmail: "",
            isLoading: false,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
          Promise.all([
            this.getTemplate(),
          ]).then((response) => {
            if (response && response.length > 0) {
              this.contractList = response[0].data;
              if (this.contractList && this.contractList.length > 0) {
                this.item = this.contractList[0];
                this.contractList.map(item => {
                  if (item.senderSignImageUrl !== "") {
                    this.senderSignImageRawData = item.senderSignImageUrl;
                    convertImgToDataURLviaCanvas(item.senderSignImageUrl, (imageRawData) => {
                      this.senderSignImageRawData = imageRawData;
                    })
                  }
                  if (item.recipientSignImageUrl !== "") {
                    this.recipientSignImageRawData = item.recipientSignImageUrl;
                    convertImgToDataURLviaCanvas(item.recipientSignImageUrl, (imageRawData) => {
                      this.recipientSignImageRawData = imageRawData;
                    })
                  }
                })
              }

              this.onCheckOption();

              this.autoHeightTextArea();
            }
          })
        },
        getTemplate() {
            return api.get(`/admin/api/center/0/staff/0/contract/template/send/${this.templateSendId}`);
        },
        postUploadEmailFiles() {
          return api.post(`/admin/api/center/0/staff/0/contract/send/email/upload`, {
            uploadFiles: this.uploadEmailFiles,
          });
        },
        async send_email() {
          // 감사추적 pdf파일 생성 및 업로드
          // 전자계약서 pdf파일 생성 및 업로드
          if (this.uploadEmailFiles.length === 0) {
            this.onPDFUpload(0);
            this.onPDFUpload(1);
          }

          this.sendEmailPop = true;
        },
        async contract_confirm() {
            this.$router.push({
              path: `/mobile/user/contract/${this.templateSendId}`
            });
        },

      autoHeightTextArea() {
        setTimeout(() => {
          let areas = document.querySelectorAll("textarea");
          for (var i = 0; i < areas.length; i++) {
            areas.item(i).style.height = "auto"
            areas.item(i).style.height = areas.item(i).scrollHeight + "px"
          }
        }, 10)
      },

      onCheckOption() {
        let flag = true;
        this.contractList.map(item => {
          if (item.templateInfo) {
            item.templateInfo.map(it => {
              if (it.type == 2 && it.requiredFlag) {
                // if (!it.checked) flag = false;
                if (it.options) {
                  let checkCount = 0;
                  it.options.map(jt => {
                    if (jt.checked) checkCount ++;
                  })
                  if (checkCount === 0 && it.options.length > 0) {
                    flag = false;
                  }
                }
              }
            })
          }
        })

        this.signEnable = flag;
      },

      onPDFUpload(type) { // type == 0 : 감사추적인증서, type == 1 : 전자계약서
        setTimeout(() => {
          let element = document.createElement("div");
          element.style.padding = "20px";
          let contract = document.querySelector(".contract-content-info");
          if (type === 0) {
            contract = document.querySelector(".contract-content-info-gratitude");
          }

          let html = contract.innerHTML.toString().replace(new RegExp("textarea", 'g'), "div");
          html = html.toString().replace(new RegExp("\n", 'g'), "<br>");
          element.innerHTML = html;
          let filename = this.contractList[0].e_contract_title + '.pdf';
          if (type === 0) {
            filename = '감사추적인증서.pdf';
          }
          let opt = {
            filename: filename,
            enableLinks: true,
            image: { type: 'jpeg', quality: 0.98 },
            pagebreak: { mode: 'avoid-all' },
            html2canvas: {
              scale: 3,
              y: 0,
              scrollY: 0,
              useCORS: true,
              width: 800,
              // height: 1130,
              letterRendering: false,
              allowTaint: false, //useCORS를 true로 설정 시 반드시 allowTaint를 false처리 해주어야함
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          }
          let pdfFile = null;
          html2pdf().from(element).set(opt).toPdf()
          .get('pdf')
          .then(pdf => {
            const blob = pdf.output('blob');
            console.log(blob)
            // Blob 데이터를 파일 객체로 변환
            pdfFile = new File([blob], filename, {type: 'application/pdf'});
            this.close()
          });
          setTimeout(() => {
            this.pdfFile1 = pdfFile;
            this.setUploadEmailFile(pdfFile);
          }, 1000)
        }, 1);
      },
      async setUploadEmailFile(file) {
        let base64data = await this.readFileAsync(file);
        base64data = base64data.split(',')[1];
        const fileInfo = {
          filename: file.name,
          mimetype: file.type,
          base64data: base64data,
          type: 1,
        };
        console.log(fileInfo);
        this.uploadEmailFiles.push(fileInfo);
      },
      handleCancelSendEmail() {
        this.sendEmailPop = false
        this.sendEmail = ""
      },

      async handleConfirmSendEmail() {
        // 이메일 체크
        if (this.validateEmail()) {
          this.isLoading = true
          console.log("pdf 파일 갯수 = " + this.pdfFiles.length)
          if (this.pdfFiles.length > 0) {
            await this.setUploadEmailFile(this.pdfFiles[0])
          }

          const date = new Date(this.contractList[0].sendTime);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

          let content = `<div>안녕하세요, 핏투데이케어입니다.</div>

<div>${this.contractList[0].recipientName}님이 ${this.contractList[0].centerName}과 ${formattedDate}일에 계약하신 계약서가 도착했습니다.</div>

<div>문서 내용을 확인해 보세요.</div>
<div></div>

<div>서명 요청자: ${this.contractList[0].centerName}</div>

<div>서명자: ${this.contractList[0].recipientName}</div>

<div>서명 완료시간: ${formattedDate}</div>
<div></div>

<div>· 이 메일의 링크를 공유하지 마십시오.</div>
<div>· 계약 만료일 전까지 이 메일 계정을 삭제하지 마십시오.</div>
<div></div>
<div>감사합니다.</div>
<div>핏투데이케어 드림</div>`;

          Promise.all([
            this.postUploadEmailFiles(),
          ]).then(async (response) => {
            console.log("file upload = " + response[0].data);
            if (response) {
              const {data} = await api.post(`/admin/api/center/0/staff/0/contract/send/email`, {
                sendEmail: this.sendEmail,
                uploadFiles: this.uploadEmailFiles,
                sendContent: content,
                fileGroupID: response[0].data
              });

              if (data) {
                alert('이메일이 발송되었습니다.');
              }
            }
            this.isLoading = false
            this.sendEmailPop = false
            this.sendEmail = ""
          });
        } else {
          alert('이메일을 정확히 입력해 주세요.');
        }
      },
      validateEmail() {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!this.sendEmail) {
          return false
        } else return emailPattern.test(this.sendEmail);
      },
      // File reader
      readFileAsync(file) {
        return new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.onload = () => {
            resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      },
      onPDFDownload() {
        setTimeout(() => {
          let element = document.createElement("div");
          element.style.padding = "20px";

          let contract = document.querySelector(".contract-content-info-gratitude");

          let html = contract.innerHTML.toString().replace(new RegExp("textarea", 'g'), "div");
          html = html.toString().replace(new RegExp("\n", 'g'), "<br>");
          element.innerHTML = html;
          let filename = this.contractList[0].e_contract_title + '.pdf';
          let opt = {
            filename: this.contractList[0].e_contract_title + '.pdf',
            enableLinks: true,
            image: { type: 'jpeg', quality: 0.98 },
            pagebreak: { mode: 'avoid-all' },
            html2canvas: {
              scale: 3,
              y: 0,
              scrollY: 0,
              useCORS: true,
              width: 800,
              // height: 1130,
              letterRendering: true,
              allowTaint: false, //useCORS를 true로 설정 시 반드시 allowTaint를 false처리 해주어야함
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          }

          html2pdf().from(element).set(opt).toPdf()
          .get('pdf')
          .then(function (pdf) {
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            this.close()
          });

        }, 1);
      },
    },
};
</script>
<style lang='scss'>
.login-wrap {
    width: 100%;
    margin: 0 auto 0;
    border-radius: 5px;

    .input-area {
        .ui-select {
            width: 100%;
            margin-bottom: 10px;
        }
    }

    input {
        width: 100%;

        + input {
            margin-top: 10px;
        }
    }

    .btn-area {
        position: fixed;
        bottom: 10px;
        .com-btn {
            width: 100%;
        }
    }
}
</style>
